
/**
 * ContainerStylesProcessor - Creates styles for the main calculator container
 */
export class ContainerStylesProcessor {
  static createContainerStyles(): string {
    return `
      /* Base styles for the calculator container */
      .onexip-calculator-container {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
        color: #0f172a !important;
        box-sizing: border-box !important;
        line-height: 1.5 !important;
        font-size: 16px !important;
        max-width: 100% !important;
        width: 100% !important;
        text-align: left !important;
      }
      
      /* Reset all elements inside our container */
      .onexip-calculator-container *,
      .onexip-calculator-container *::before,
      .onexip-calculator-container *::after {
        box-sizing: border-box !important;
        max-width: 100% !important;
        font-family: inherit !important;
      }
    `;
  }
}
